<template>
  <v-form v-model="valid" @submit="submitForm" class="search-form-container">
    <v-card>
      <v-container grid-list-xl>
        <v-layout wrap class="search-form">
          <v-flex sm4 class="pl-2 pr-1">
            <!-- <v-menu :close-on-content-click="false">
              <template v-slot:activator="{ on }">
                <v-text-field
                  background-color="#F1F2F6"
                  v-model="location_text"
                  :label="trans('search.location', null, '...')"
                  height="28"
                  prepend-inner-icon="mdi-map-marker"
                  filled
                  v-on="on"
                  placeholder
                  hide-details
                ></v-text-field>
              </template>
              <v-card>
                <v-container>
                  <v-text-field
                    background-color="#F1F2F6"
                    :label="trans('search.location', null, '...')"
                    :rules="location_rules"
                    height="28"
                    prepend-inner-icon="mdi-map-marker"
                    v-model="location_text"
                    filled
                    v-on="on"
                    ref="autocomplete"
                    placeholder
                    hide-details
                  ></v-text-field>
                </v-container>
              </v-card>
            </v-menu>-->

            <v-text-field
              background-color="#F1F2F6"
              :label="trans('search.location', null, '...')"
              height="28"
              prepend-inner-icon="mdi-map-marker"
              v-model="location_text"
              outlined
              ref="autocomplete"
              hide-details
            ></v-text-field>
          </v-flex>

          <v-flex sm2 class="px-1">
            <v-menu
              v-model="datepicker_active"
              background-color="#F1F2F6"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  :key="'available'"
                  :label="trans('search.arrival_date', null, '...')"
                  :rules="available_from_rules"
                  background-color="#F1F2F6"
                  height="28"
                  outlined
                  v-model="available_from"
                  prepend-inner-icon="mdi-calendar-range-outline"
                  readonly
                  v-on="on"
                  hide-details
                ></v-text-field>
              </template>
              <v-date-picker
                :min="min_date"
                v-model="available_from"
                @input="datepicker_active = false"
                :locale="locale"
              ></v-date-picker>
            </v-menu>
          </v-flex>

          <v-flex sm2 class="px-1">
            <v-select
              :key="'property'"
              :items="property_types"
              :label="trans('search.property_type_home', null, '...')"
              height="28"
              prepend-inner-icon="mdi-home-city-outline"
              v-model="property_type"
              outlined
              background-color="#F1F2F6"
              hide-details
            ></v-select>
          </v-flex>
          <v-flex sm2 class="px-1">
            <occupants-picker
              :value="occupants_value"
              @changeValue="changeOccupants"
              :pickers="occupant_pickers"
              label="guests"
            />
          </v-flex>
          <v-flex sm2>
            <v-btn
              type="submit"
              depressed
              block
              color="primary"
              height="56"
              @click.prevent="submitForm"
            >
              <span>{{ trans('app.search', null, '...') }}</span>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </v-form>
</template>

<script>
import _ from "lodash";
import { mapGetters, mapActions, mapState } from "vuex";
import {
  COUNTRY_CODE,
  COUNTRY_BOUNDS,
  MAP_CENTER,
  DEFAULT_LOCATION,
} from "@/config";
import OccupantsCountPicker from "../components/occupants-picker/OccupantsCountPicker.vue";
export default {
  components: {
    "occupants-picker": OccupantsCountPicker,
  },
  data: () => ({
    autocomplete: null,
    datepicker_active: false,
    valid: false,
    occupant_pickers: [
      { label: "Adults", note: "Ages 13 and above", value: 1, id: "adults" },
      { label: "Chidren", note: "Ages 2-12", value: 1, id: "children" },
      { label: "Infants", note: "Under 2", value: 1, id: "infants" },
    ],
  }),

  computed: {
    ...mapState("search", {
      query: "query",
    }),
    ...mapState("locale", {
      locale: "locale",
    }),
    occupants_value: function () {
      if (!this.query["occupants"]) return "";
      return `${this.query["occupants"]} guests, ${this.infants} infants`;
    },
    infants() {
      let infant = this.occupant_pickers.find((item) => item.id == "infants");
      if (!infant) return null;
      return infant.value;
    },
    property_types: function () {
      return [
        {
          text: this.trans("search.property_type_room"),
          value: "room",
        },
        {
          text: this.trans("search.property_type_apartment"),
          value: "apartment",
        },
      ];
    },

    min_date: function () {
      return new Date().toISOString().split("T")[0];
    },

    location: {
      get: function () {
        let v = _.get(this.query, "location");
        return v;
      },
      set: function (v) {
        return this.setQueryParam({ location: v });
      },
    },

    available_from: {
      get: function () {
        let v = _.get(this.query, "available_from");
        return v;
      },
      set: function (v) {
        return this.setQueryParam({ available_from: v });
      },
    },

    property_type: {
      get: function () {
        let v = _.get(this.query, "property_type");
        return v;
      },
      set: function (v) {
        return this.setQueryParam({ property_type: v });
      },
    },

    location_text: {
      get: function () {
        let v = _.get(this.query, "location.formatted_address", null);
        return v;
      },
      set: function (v) {
        return;
      },
    },

    location_rules: function () {
      return [
        (v) => !!v || "This field is required",
        (v) => !!this.location || "This field is required",
      ];
    },
    available_from_rules: function () {
      return [
        (v) =>
          v != null
            ? /\d{4}-\d{2}-\d{2}/.test(v) || "Invalid date provided"
            : true,
      ];
    },
  },

  mounted: function () {
    this.resetQuery();
    // remove standart google input placeholder
    setTimeout(() => {
      let input = this.$refs["autocomplete"].$el.querySelector("input");
      input.setAttribute("placeholder", "");
    }, 0);
    this.$google.then((google) => {
      let input = this.$refs["autocomplete"].$el.querySelector("input");
      input.setAttribute("placeholder", "");
      let options = {
        bounds: {
          ...COUNTRY_BOUNDS,
        },
        componentRestrictions: {
          country: [COUNTRY_CODE],
        },
        types: ["geocode"],
        fields: [
          "geometry",
          "place_id",
          "formatted_address",
          "address_components",
        ],
        strictBounds: true,
      };

      this.autocomplete = new google.maps.places.Autocomplete(input, options);

      this.autocomplete.addListener("place_changed", () => {
        let response = this.autocomplete.getPlace();
        this.onPlaceChanged(response);
      });
    });
  },

  methods: {
    ...mapActions("search", {
      fetch: "fetch",
      setQuery: "setQuery",
      setQueryParam: "setQueryParam",
      resetQuery: "resetQuery",
    }),

    onPlaceChanged: function (response) {
      this.location = {
        ...response.geometry.location.toJSON(),
        ...response.geometry.viewport.toJSON(),
        formatted_address: response.formatted_address,
        place_id: response.place_id,
        zoom: this.calculateZoom(response),
      };
    },

    calculateZoom: function (response) {
      let globe_width = 256; // a constant in Google's map projection
      let pixel_width = 256;
      let { east, west } = response.geometry.viewport.toJSON();
      let angle = east - west;
      if (angle < 0) angle += 360;
      let zoom = Math.ceil(
        Math.log((pixel_width * 360) / angle / globe_width) / Math.LN2
      );
      return Math.min(zoom, 21);
    },
    calculateOccupants() {
      let occupants = 0;
      this.occupant_pickers.forEach((item) => {
        if (item.id == "adults" || item.id == "children") {
          occupants += item.value;
        }
      });

      this.setQueryParam({ occupants });
    },
    submitForm: function (e) {
      this.$router.push({ name: "search" });
    },
    changeOccupants: function (id, value) {
      this.occupant_pickers = this.occupant_pickers.map((item) => {
        if (item.id == id) item.value = value;
        return item;
      });
      this.calculateOccupants();
    },
  },
};
</script>
<style lang="scss" >
.search-form {
  &-container {
    z-index: 2;
  }
  max-width: 900px;
  & .v-text-field--outlined fieldset {
    border-color: transparent;
  }
  & .v-text-field--outlined.v-input--is-focused fieldset,
  .v-text-field--outlined.v-input--has-state fieldset {
    border: 2px solid currentColor !important;
  }
}
</style>